import React, { useMemo, useState } from "react";
import { Button, Avatar, Empty } from "antd";
import { CheckCircleTwoTone } from "@ant-design/icons";
import ImageAvatar from "../../assets/2.png";
import { getProviderImage } from "../../utils/providerImageUtil";

export default function StepProvider({
  formData,
  setFormData,
  onNext,
  onBack,
  providerConfig,
}) {
  const [selectedId, setSelectedId] = useState(
    formData.selectedProvider?.member_id || null
  );

  const providers = useMemo(() => {
    const all = providerConfig?.providers || [];
    const abbr = formData.selectedState?.abbr;
    if (!abbr) return [];
    return all.filter((p) =>
      (p.supported_states || [])
        .map((x) => String(x).toUpperCase())
        .includes(String(abbr).toUpperCase())
    );
  }, [providerConfig, formData.selectedState]);

  const handleSelect = (p) => {
    setSelectedId(p.member_id);
    setFormData({
      ...formData,
      selectedProvider: {
        member_id: p.member_id,
        display_name: p.display_name,
        image: getProviderImage(p, ImageAvatar),
      },
    });
  };

  return (
    <div className="step-provider" style={{ width: "100%" }}>
      <h2 className="form-title text-white">Select provider</h2>
      <p className="text-white" style={{ marginBottom: 20, opacity: 0.9 }}>
        Choose a provider licensed in{" "}
        <strong>{formData.selectedState?.name || "your state"}</strong>.
      </p>

      {!providers.length ? (
        <Empty
          description={
            <span className="text-white">
              No providers available for this state. Please go back or use
              &quot;I don&apos;t see my state&quot; for assistance.
            </span>
          }
        />
      ) : (
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
            gap: 20,
            marginBottom: 24,
          }}
        >
          {providers.map((p) => (
            <div
              key={p.member_id}
              onClick={() => handleSelect(p)}
              style={{
                backgroundColor: "#fff",
                border:
                  selectedId === p.member_id
                    ? "2px solid #fc8c02"
                    : "1px solid #ddd",
                borderRadius: 10,
                padding: 16,
                cursor: "pointer",
                textAlign: "center",
                boxShadow:
                  selectedId === p.member_id
                    ? "0 0 10px rgba(252,140,2,0.4)"
                    : "0 2px 8px rgba(0,0,0,0.05)",
              }}
            >
              {selectedId === p.member_id && (
                <CheckCircleTwoTone
                  twoToneColor="#fc8c02"
                  style={{ marginBottom: 8 }}
                />
              )}
              <Avatar
                size={80}
                src={getProviderImage(p, ImageAvatar)}
                alt={p.display_name}
                style={{ marginBottom: 12 }}
              />
              <div style={{ fontWeight: 600, fontSize: 16, color: "#000" }}>
                {p.display_name}
              </div>
            </div>
          ))}
        </div>
      )}

      <div style={{ display: "flex", gap: "1rem" }}>
        <Button className="btn-css-class" onClick={onBack} block>
          Back
        </Button>
        <Button
          type="primary"
          size="large"
          block
          disabled={!selectedId}
          onClick={onNext}
          className="btn-css"
        >
          Continue
        </Button>
      </div>
    </div>
  );
}
